import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { auditService } from '../../services/api/audit.service';

export const fetchActionTypes = createAsyncThunk(
  'audit/fetchActionTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await auditService.getActionTypes();
      return response.data;   // array of action types
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch action types');
    }
  }
);

export const fetchAuditSearch = createAsyncThunk(
  'audit/fetchAuditSearch',
  async (params, { rejectWithValue }) => {
    try {
      const response = await auditService.getAuditSearch(params);
      return response.data;   // array of action types
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch action types');
    }
  }
);

const initialState = {
    actionTypes: [],
    isLoading: false,
    error: null,
    auditSearch: [],
    isLoadingAuditSearch: false,
    errorAuditSearch: null,
  };
  
  const auditSlice = createSlice({
    name: 'audit',
    initialState,
    reducers: {
      clearAuditError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchActionTypes.pending, (state) => { state.isLoading = true; state.error = null; })
        .addCase(fetchActionTypes.fulfilled, (state, action) => { 
          state.isLoading = false;
          state.actionTypes = action.payload; 
        })
        .addCase(fetchActionTypes.rejected, (state, action) => { 
          state.isLoading = false; 
          state.error = action.payload; 
        })

        .addCase(fetchAuditSearch.pending, (state) => { state.isLoadingAuditSearch = true; state.errorAuditSearch = null; })
        .addCase(fetchAuditSearch.fulfilled, (state, action) => { 
          state.isLoadingAuditSearch = false;
          state.auditSearch = action.payload; 
        })
        .addCase(fetchAuditSearch.rejected, (state, action) => { 
          state.isLoadingAuditSearch = false; 
          state.errorAuditSearch = action.payload; 
        })
    },
  });
  
  export const { clearAuditError } = auditSlice.actions;
  export default auditSlice.reducer;
  